/**
 * Insurance Agencies Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageNotificationsComponent,
  AsyncAddNotificationComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageNotificationsComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddNotificationComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
